export const environment = {
  production: true,
  serveur_name: 'https://backend.irbe7.com',
  host_name: 'https://backend.irbe7.com',
  keycloak_host: 'https://keyck.irbe7.com/auth',
  keycloak_serveur: 'https://keyck.irbe7.com/auth',
  keycloak_client_secret: '1L4l6jAjrl33J40pXGndRNnYpACHd6Ez',
  keycloak_client_id: 'irbe7-backend',
  data_host: 'https://data.irbe7.com',
  cloud_front_host: 'https://d3b156xx8s447.cloudfront.net/',
  apiUrl: 'https://irbe7.com',
  onesignal_appId: 'fd87e31c-2cc2-4a2d-a2e0-f656c2f195fa',
};
